/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Sync_Changes_Error_ToastInputs */



/**
* | output |
* | --- |
* | "There was an error syncing changes. {error}" |
*
* @param {Sync_Changes_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_error_toast = /** @type {((inputs: Sync_Changes_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Une erreur est survenue lors de la synchronisation des modifications. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Beim Synchronisieren der Änderungen ist ein Fehler aufgetreten. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Si è verificato un errore durante la sincronizzazione delle modifiche. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Произошла ошибка синхронизации изменений. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Hubo un error al sincronizar los cambios. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`同步更改时出错。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`変更の同期中にエラーが発生しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`परिवर्तनों को सिंक्रनाइज़ करने में त्रुटि हुई। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Ocorreu um erro ao sincronizar as alterações. ${i?.error}`)
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
});